import { UserState } from "actors/user.actor";
import ActionButton from "components/widgets/action-button";

import { gameActor, itemService } from "services";
import { GuiState } from "states/gui.state";
import { GameState } from "actors/game.actor";
import { DigimonState } from "actors/digimon.actor";
import { ItemDefDto } from "dtos/item.dto";

export default function ToyActions(props: {
    gui: GuiState,
    game: GameState,
    user?: UserState,
    digimon?: DigimonState,
})
{
    // Actions:
    const holdToy = (itemDefDto: ItemDefDto) => {
        if (props.user!.item?.name === itemDefDto.name && props.user!.item?.type === itemDefDto.type) {
            gameActor.userActor?.holdItem(null);
            return;
        }
        gameActor.userActor?.holdItem(itemDefDto);
    }

    // Component:
    const buttons: JSX.Element[] = itemService.toyItems.map(itemDefDto => (
        <ActionButton
            key={itemDefDto.name}
            item={itemDefDto.name}
            type={itemDefDto.type}
            name={itemDefDto.display}
            description={itemService.getDescription(itemDefDto.name, itemDefDto.type, props.digimon?.dto)}
            metadata={itemService.getHighs(itemDefDto)}
            active={props.user!.action === "toys" && props.user!.item?.name === itemDefDto.name && props.user!.item?.type === itemDefDto.type}
            onClick={() => holdToy(itemDefDto)}
            tooltipColor={itemService.getColor(itemDefDto.type)}
        />
    ));
    return props.user?.action === "toys" ? (
        <>{buttons}</>
    ) : (<></>);
}